import api from "./core";

const basePath = "api/core/ChatMessages";

const BaseURL = require("./serverCfg").default.coreBaseUrl;

export default {
  create(data) {
    const {
      SenderType,
      PatientId,
      SenderUserId,
      PortalUserId,
      Relationship,
      DateTime,
      Message,
      Files,
      FilesData
    } = data;
    var formData = new FormData();
    formData.append("SenderType", SenderType);
    formData.append("PatientId", PatientId);
    formData.append("SenderUserId", SenderUserId);
    formData.append("PortalUserId", PortalUserId);
    formData.append("DateTime", DateTime);
    formData.append("Message", Message);
    formData.append("Relationship", Relationship);
    if (Files) {
      for (let index = 0; index < Files.length; index++) {
        const File = Files[index];
        formData.append("Files", File);
      }
      formData.append("FilesData", FilesData);
    }

    const config = {
      "Hide-Loading": true
    };

    return api.put(`${basePath}`, formData, config);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`, {
      "Hide-Loading": true
    });
  },
  find(id) {
    return api.get(`${basePath}/${id}`, {
      "Hide-Loading": true
    });
  },
  downloadUrl(id) {
    return `${BaseURL}${basePath}/Download/${api.getToken()}/${id}`;
  },
  avatarUrl(id) {
    return `${BaseURL}${basePath}/DownloadAvatar/${api.getToken()}/${id}`;
  },
  sendMany(data) {
    const config = {
      "Hide-Loading": true
    };
    return api.put(`${basePath}/SendMany`, data, config);
  }
};
